import Badge from '@/components/Badge';
import { NoshowAlertStatus } from '@/types/noshowAlerts';

const STATUS_CONFIG: Record<
  NoshowAlertStatus,
  { label: string; status: string }
> = {
  pending: { label: 'Pending', status: 'neutral' },
  sms_sent: { label: 'SMS Sent', status: 'theme' },
  reminder_sent: { label: 'Reminder Sent', status: 'theme' },
  confirmed_present: { label: 'Present', status: 'success' },
  confirmed_noshow: { label: 'No-Show', status: 'danger' },
  backfill_requested: { label: 'Backfill Needed', status: 'warning' },
  awaiting_backfill: { label: 'Awaiting Backfill', status: 'warning' },
  backfill_declined: { label: 'Backfill Declined', status: 'neutral' },
  escalated: { label: 'Escalated', status: 'danger' },
  multi_worker_flagged: { label: 'Multi-Worker', status: 'warning' },
  resolved: { label: 'Resolved', status: 'neutral' },
};

interface StatusBadgeProps {
  status: NoshowAlertStatus;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const config = STATUS_CONFIG[status] || {
    label: status,
    status: 'neutral',
  };
  return <Badge label={config.label} status={config.status} />;
};

export default StatusBadge;
